import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

// Payer name with its aliases on a muted second line.
// Reads PayerName / Aliases (", "-delimited) from the row data; works as the
// innerRenderer of agGroupCellRenderer so it sits beside the master/detail chevron.
@Component({
    selector: 'app-ag-payer-cell-renderer',
    templateUrl: './ag-payer-cell-renderer.component.html',
    styleUrl: './ag-payer-cell-renderer.component.scss'
})
export class AgPayerCellRendererComponent implements ICellRendererAngularComp {

  name = '';
  aliases = '';

  agInit(params: ICellRendererParams): void {
    this.setValue(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setValue(params);
    return true;
  }

  private setValue(params: ICellRendererParams) {
    this.name = params.data?.PayerName ?? '';
    this.aliases = params.data?.Aliases ?? '';
  }
}
